import feather from 'feather-icons';

window.feather = feather;

export default feather;
